import axios from 'axios';

const api = axios.create({
  baseURL: '/api', // Caminho relativo, Nginx vai enviar para a API
  timeout: 100000000000000000, // Tempo limite da requisição em milissegundos
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

export default api;
